import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex xl:flex-row flex-col h-screen relative" }
const _hoisted_2 = { class: "flex flex-col flex-1 relative overflow-hidden" }

import SidebarMenu from "@/components/SidebarMenu.vue";
import PageFooter from "@/components/PageFooter.vue";
import CalculatorSidebarItems from "@/components/sidebar/CalculatorSidebarItems.vue";
import PageHeader from "@/components/headers/PageHeader.vue";
import BlogButton from "@/components/buttons/BlogButton.vue";
import { useSafeBack } from "@/utils/useSafeBack";
import { ROUTE_NAMES } from "@/constants/routeNames";
import pageBg from "@/assets/calculators/calculator_bg.webp";
import { ref } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'CalculatorLayout',
  props: {
    withOverflow: { type: Boolean },
    showBgImage: { type: Boolean, default: true }
  },
  setup(__props: any) {



const { safeBack } = useSafeBack();

const isMenuOpen = ref(false);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SidebarMenu, {
      "show-blog-btn": false,
      "is-menu-open": isMenuOpen.value,
      onToggleMenu: _cache[1] || (_cache[1] = ($event: any) => (isMenuOpen.value = !isMenuOpen.value))
    }, {
      default: _withCtx(() => [
        _createVNode(CalculatorSidebarItems, {
          onCloseMenu: _cache[0] || (_cache[0] = ($event: any) => (isMenuOpen.value = false))
        })
      ]),
      _: 1
    }, 8, ["is-menu-open"]),
    _createElementVNode("main", _hoisted_2, [
      _createVNode(PageHeader, {
        onClose: _cache[2] || (_cache[2] = ($event: any) => (_unref(safeBack)(_unref(ROUTE_NAMES).HOME))),
        class: "hidden xl:flex"
      }, {
        "header-content": _withCtx(() => [
          _createVNode(BlogButton, { class: "hidden xl:flex" })
        ]),
        _: 1
      }),
      _createElementVNode("section", {
        class: _normalizeClass([
          'flex-1 bg-secondary bg-cover bg-center',
          { 'overflow-hidden': !__props.withOverflow },
        ]),
        style: _normalizeStyle(__props.showBgImage ? { backgroundImage: `url(${_unref(pageBg)})` } : {})
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 6),
      _createVNode(PageFooter)
    ])
  ]))
}
}

})